import { useState } from 'react'
import {
  Box,
  Grid,
  Stack,
  Typography,
  TextField,
} from '@elphasecure/elpha-design-system'
import { ThemedButton } from '.'
import {
  useStripe,
  useElements,
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
} from '@stripe/react-stripe-js'
import { toast } from 'react-toastify'
import EICardGroup from '../assets/images/EICardGroup.jpg'
import EICardCVC from '../assets/images/EICardCVC.jpg'

interface StripeFormProps {
  handleNext: () => void
  sx?: any
  clientSecret: any
  postalCode?: any
  setPostalCode?: (e: any) => void
  isLoadingBillingInfo?: boolean
  postalCodeError?: boolean
}

export const StripeForm = ({
  handleNext,
  sx,
  clientSecret,
  postalCode,
  setPostalCode,
  isLoadingBillingInfo,
  postalCodeError,
}: StripeFormProps) => {
  const [isLoading, setIsLoading] = useState(false)

  const stripe: any = useStripe()
  const elements: any = useElements()
  const options = {
    style: {
      base: {
        color: '#424770',
        letterSpacing: '0.025em',
        fontSize: '16px',
        fontFamily: 'sofia-pro, arial, sans-serif',
      },
    },
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (!stripe || !elements) {
      return
    }

    setIsLoading(true)

    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: elements.getElement(CardNumberElement),
      },
    })
    if (result.error) {
      toast.error(result.error)
    } else {
      handleNext()
    }
    setIsLoading(false)
  }

  return (
    <form onSubmit={handleSubmit}>
      <Stack direction={'column'} sx={{ ...sx }}>
        <Grid container spacing="2.8rem">
          <Grid item xs={12}>
            <Box className="stripe-input">
              <Box
                sx={{
                  position: 'absolute',
                  top: '10px',
                  right: '18px',
                }}
              >
                <img
                  src={EICardGroup}
                  alt="card-providers"
                  height="25px"
                  width="150px"
                />
              </Box>
              <CardNumberElement options={{ ...options, placeholder: '' }} />
              <label>Card Number</label>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="stripe-input">
              <CardExpiryElement options={{ ...options, placeholder: '' }} />
              <label>Expiration Date</label>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="stripe-input">
              <Box
                sx={{
                  position: 'absolute',
                  top: '10px',
                  right: '18px',
                }}
              >
                <img
                  src={EICardCVC}
                  alt="card-cvc"
                  height="25px"
                  width="35px"
                />
              </Box>
              <CardCvcElement options={{ ...options, placeholder: '' }} />
              <label>CVC</label>
            </Box>
          </Grid>
          {setPostalCode && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Postal Code"
                color="primary"
                variant="outlined"
                type="number"
                value={postalCode}
                error={postalCodeError}
                onChange={(e) => setPostalCode(e.target.value)}
              />
            </Grid>
          )}
        </Grid>
        <Box>
          <ThemedButton
            variant="contained"
            type="submit"
            disabled={!stripe || isLoading || isLoadingBillingInfo}
            color="secondary"
            sx={{
              marginTop: '2.8rem',
              width: '12.4rem',
              alignSelf: 'flex-start',
            }}
          >
            <Typography noWrap>Pay Now</Typography>
          </ThemedButton>
        </Box>
      </Stack>
    </form>
  )
}
